// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import type { ReactNode } from 'react';
import { AppIcon } from './AppIcon';
import './NotificationEmptyState.css';

export interface NotificationEmptyStateProps {
  icon?: ReactNode;
  title?: string;
  message?: string;
  className?: string;
}

export function NotificationEmptyState({
  icon,
  title = 'No notifications yet',
  message = 'When you receive notifications, they will appear here.',
  className = '',
}: NotificationEmptyStateProps) {
  const classes = ['fin-notif-empty', className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className="fin-notif-empty__icon">
        {icon || <AppIcon name="bell" color="grey" size="big" />}
      </div>
      <p className="fin-notif-empty__title">{title}</p>
      <p className="fin-notif-empty__message">{message}</p>
    </div>
  );
}
